import React, {useState, useEffect} from "react";
import axios from "axios";

export const YotpoContext = React.createContext();


export const YotpoContextProvider = ({children, apiKey}) => {

  let urlSort, urlPage, urlSearch;
  const urlParams = new URLSearchParams(location.search);
  try{
    urlSort = JSON.parse(urlParams.get("sort"));
    urlPage = urlParams.get("page");
    urlSearch = urlParams.get("search");
  }catch(e){
    console.error(e);
  }

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState(urlSearch);
  const [sorting, setSorting] = useState(urlSort ? urlSort : {
    "sort_by": "date",
    "ascending": false
  });
  const [scores, setScores] = useState([])
  const [page, setPage] = useState(urlPage || 1);
  const [pages, setPages] = useState(null);
  const [total1, setTotal1] = useState(null);
  const [total2, setTotal2] = useState(null);
  const [total3, setTotal3] = useState(null);
  const [total4, setTotal4] = useState(null);
  const [total5, setTotal5] = useState(null);
  const [products, setProducts] = useState([]);

  const updateUrl = () => {

    if(sorting["sort_by"] != "date" || sorting["ascending"]){
      const sortingValue = JSON.stringify(sorting);
      urlParams.set("sort", sortingValue);
    }else{
      urlParams.delete("sort");
    }

    if(scores.length){
      const scoresValue = JSON.stringify(scores);
      urlParams.set("scores", scoresValue);
    }else{
      urlParams.delete("scores");
    }
    if(page > 1){
      urlParams.set("page", page);
    }else{
      urlParams.delete("page");
    }
    if(search){
      urlParams.set("search", search.trim());
    }else{
      urlParams.delete("search");
    }

    history.replaceState({foo:"bar"}, "", location.pathname + (urlParams.toString().length ? "?" + urlParams.toString() : "") + location.hash)

  }

  //get bottomline
  useEffect(() => {
    getTotals();
  }, []);

  //get some reviews
  useEffect(() => {
    updateUrl();
    getReviews();
  }, [page, sorting, scores, search]);

  const getTotals = async () => {

    const searchUrl = `https://api-cdn.yotpo.com/v1/reviews/${apiKey}/filter.json?page=${page}&per_page=20`;

    const results1 = await axios.post(searchUrl, {
      "scores": [1]
    });
    const results2 = await axios.post(searchUrl, {
      "scores": [2]
    });
    const results3 = await axios.post(searchUrl, {
      "scores": [3]
    });
    const results4 = await axios.post(searchUrl, {
      "scores": [4]
    });
    const results5 = await axios.post(searchUrl, {
      "scores": [5]
    });

    const total1 = results1 && results1.data && results1.data.response && results1.data.response.pagination && results1.data.response.pagination.total;
    const total2 = results2 && results2.data && results2.data.response && results2.data.response.pagination && results2.data.response.pagination.total;
    const total3 = results3 && results3.data && results3.data.response && results3.data.response.pagination && results3.data.response.pagination.total;
    const total4 = results4 && results4.data && results4.data.response && results4.data.response.pagination && results4.data.response.pagination.total;
    const total5 = results5 && results5.data && results5.data.response && results5.data.response.pagination && results5.data.response.pagination.total;

    setTotal1(total1);
    setTotal2(total2);
    setTotal3(total3);
    setTotal4(total4);
    setTotal5(total5);
  }

  const getReviews = async () => {
    setLoading(true);
    //const searchUrl = `https://api-cdn.yotpo.com/v1/widget/${apiKey}/products/yotpo_site_reviews/reviews.json`;
    const searchUrl = `https://api-cdn.yotpo.com/v1/reviews/${apiKey}/filter.json?page=${page}&per_page=20`;

    const results = await axios.post(searchUrl, {
      "sortings": [sorting],
      "scores": scores.length ? scores : null,
      "free_text_search": search
    });
    const response = results && results.data && results.data.response;

    setLoading(false);
    if(response){
      setPages(response.pagination && (response.pagination.total ? Math.ceil(response.pagination.total / response.pagination.per_page) : null));
      setPage(response.pagination && response.pagination.page);
      setReviews(response.reviews);
      setProducts(response.products);
    }
  }

  const totals = (typeof total1 == 'number'
                  && typeof total2 == 'number'
                  && typeof total3 == 'number'
                  && typeof total4 == 'number'
                  && typeof total5 == 'number') ? {
                                  1: total1,
                                  2: total2,
                                  3: total3,
                                  4: total4,
                                  5: total5,
                                  all: total1 + total2 + total3 + total4 + total5
                                }
                              : {};

  return (
    <YotpoContext.Provider value={{ reviews, loading, filters, setFilters, page, pages, setPage, totals, sorting, setSorting, scores, setScores, search, setSearch, products}}>
      {children}
    </YotpoContext.Provider>
  );
}
